import { Divider } from '@mui/material'
import Link from '@mui/material/Link'
import { useState } from 'react'
import styles from './FooterLinks.module.scss'
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy'

export const FooterLinks = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && <PrivacyPolicy isOpen={isOpen} closeModal={closeModal} />}
      <span
        className={styles.styledLink}
        onClick={handleClick}
        aria-label="Privacy Policy"
      >
        Privacy Policy
      </span>
      <Divider
        orientation="vertical"
        variant="middle"
        className={styles.styledDivider}
      />
      <Link
        className={styles.styledLink}
        href="https://target.com"
        target="_blank"
        aria-label="Target.com opens in a new Tab"
      >
        Target.com
      </Link>
    </>
  )
}

export default FooterLinks
